import { useEffect } from 'react';
import { getMUICache, appendStyleSheet, getImageId, getImageUrl, getImageSize, convertEpochTime, fetchAnchorValue } from '../../../common/utils';
import { CacheProvider } from '@emotion/react';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import "./MediaListTwo.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
    const { showDate, showAuthor, item, cardTextColor, isCarousel, anchorLinksValue } = props;
    const { hl, au, imageid, pubInfo, wu, upd, tn, du } = item;
    const cache = getMUICache();
    AddImageDimensions();
    SetHighPriorityImages();
    PreloadViewportImages();
    ImageLoader();

    useEffect(() => {
        EagerLoadImages()
    }, []);

    let styles = require("./MediaListTwo.css");
    appendStyleSheet("MediaListTwo", styles);

    return (
        <CacheProvider value={cache}>
            {!isCarousel ?
                <div className='ThemeTwoVideoListCardMainWrap'>
                    <div className="ThemeTwoVideoListCardWrap">

                        <a role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, (wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu)))}>
                            <div className="ThemeTwoVideoListCardImgWrap">
                                <figure className="ThemeTwoVideoListCardFigureWrap">{getImageSize(imageid) && <picture>
                                    {/* Add multiple source elements for different image sources */}
                                    <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 266, 150, pubInfo.baseDomain, false, props.CONSTANTS , '8')} />
                                    <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 156, 88, pubInfo.baseDomain, false, props.CONSTANTS , '8')} />
                                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />
                                </picture>}


                                    <div className='VideoListiconWrap'>
                                        {tn === "MEDIAAUDIO" && <PodcastsIcon />}
                                        {tn === "MEDIAVIDEO" && <PlayArrowRoundedIcon />}
                                        <p className='VideoListDuration'>{du}</p>
                                    </div>

                                </figure>
                            </div>

                            <div className='ThemeTwoVideoListCarContentWrap'>
                                <p className='VideoListDiscription' style={{ color: cardTextColor }}> {hl}</p>
                            </div>
                            <div className='themeTwodateAgencyWrap'>
                                {showDate && <p className='VideoListDateTime'>{convertEpochTime(upd, 'updated', "DD MMM YYYY")}</p>}
                            </div>
                        </a>
                    </div>
                </div> :
                <div className="quickview_main_wrap">
                    <div className="quickview_wrap">
                        <a role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, (wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu)))}>
                            <figure className="image-wrapper">{getImageSize(imageid) &&
                                <picture>
                                    {/* Add multiple source elements for different image sources */}
                                    <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 266, '', pubInfo.baseDomain, false, props.CONSTANTS)} />
                                    <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 156, '', pubInfo.baseDomain, false, props.CONSTANTS)} />
                                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />
                                </picture>}</figure>

                            <div className='itemtitlewrap'>
                                <h5 className="itemTitle"> {hl}</h5>
                                <div className='authorWrap'>
                                    {(showAuthor && au !== '') && <h6 className='showauth commonset'><span className='manageAuthorName'>{au}</span></h6>}
                                    {showDate &&
                                        <div className='Authordetails'>
                                            <h6 className='showtime commonset'>{convertEpochTime(upd, 'updated', "DD MMM YYYY")}</h6>
                                        </div>
                                    }
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            }
        </CacheProvider>
    )
}
export default Card;